import { fetchWithAuthRelogin } from '../utils/sessionRelogin';
import { getMiniappAccessToken } from '../utils/miniappAccessToken';

/**
 * Финансы: цена примерки и создание платежа ЮKassa за пакет примерок.
 * База: REACT_APP_FINANCE_API_PATH или /api/finance
 */

function getFinanceBase() {
  if (typeof window === 'undefined') return '';
  const path = process.env.REACT_APP_FINANCE_API_PATH || '/api/finance';
  return `${window.location.origin}${path.replace(/\/+$/, '')}`;
}

function authJsonHeaders() {
  try {
    const token = getMiniappAccessToken();
    if (!token) return { 'Content-Type': 'application/json' };
    return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  } catch {
    return { 'Content-Type': 'application/json' };
  }
}

/**
 * @returns {Promise<{ tryon_unit_price_rub: number | null }>}
 */
export async function fetchTryonUnitPrice() {
  const res = await fetchWithAuthRelogin(`${getFinanceBase()}/settings/tryon-unit-price`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = typeof data.detail === 'string' ? data.detail : `Ошибка ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

/**
 * @param {{ quantity: number, returnUrl: string }} opts
 * @returns {Promise<{ confirmation_url?: string, id: number, amount: string, quantity: number, status: string }>}
 */
export async function createTryonPayment(opts) {
  const { quantity, returnUrl } = opts;
  const res = await fetchWithAuthRelogin(`${getFinanceBase()}/tryon-payments`, {
    method: 'POST',
    headers: authJsonHeaders(),
    body: JSON.stringify({ quantity, return_url: returnUrl }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      typeof data.detail === 'string'
        ? data.detail
        : Array.isArray(data.detail)
          ? data.detail.map((d) => d.msg || d).join(', ')
          : `Ошибка ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

/**
 * Статус tryon-платежа (для опроса после возврата из браузера оплаты).
 * @param {number} paymentId
 * @returns {Promise<{ id: number, status: string, paid: boolean, credits_granted: boolean, quantity: number }>}
 */
export async function fetchTryonPaymentStatus(paymentId) {
  const res = await fetchWithAuthRelogin(`${getFinanceBase()}/tryon-payments/${paymentId}`, {
    headers: authJsonHeaders(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      typeof data.detail === 'string'
        ? data.detail
        : Array.isArray(data.detail)
          ? data.detail.map((d) => d.msg || d).join(', ')
          : `Ошибка ${res.status}`;
    throw new Error(msg);
  }
  return data;
}
